
import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useLanguage } from '@/contexts/LanguageContext';
import { Scale, X } from 'lucide-react';

interface ComparisonFloatingButtonProps {
  count: number;
  onOpen: () => void;
  onClear: () => void;
}

const ComparisonFloatingButton: React.FC<ComparisonFloatingButtonProps> = ({
  count,
  onOpen,
  onClear
}) => {
  const { t } = useLanguage();

  if (count === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40 flex items-center gap-2">
      <Button
        onClick={onOpen}
        className="relative shadow-lg"
        size="lg"
      >
        <Scale className="h-4 w-4 mr-2" />
        {t('compare', 'مقارنة', 'Compare')}
        <Badge variant="secondary" className="ml-2">
          {count}
        </Badge>
      </Button>
      
      <Button
        variant="outline"
        size="sm"
        onClick={onClear}
        className="shadow-lg"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ComparisonFloatingButton;
